import Schema from "../classes/Schema"

export default function normalizeModel(model) {
  const isSchema = model && model.schema instanceof Schema.types.Shape

  const { name, primaryKey } = model

  /* Schema by normalir is deprecated */
  /* DOTO: Remove schema */
  const schema = isSchema ? model.schema : model
  const { getUrl, getRestUrn } = model

  return {
    name,
    primaryKey,
    schema,
    getUrl,
    getRestUrn,
  }
}
